import { ArrowRight, Phone } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalProvider";

export const CtaButtons = ({ className = "", dark = false }) => {
  const { openBooking, openQuote } = useLeadModal();
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <button onClick={openQuote} data-testid="cta-quote-btn"
        className="group px-7 py-4 rounded-full bg-leaf text-white font-medium flex items-center justify-center gap-2 transition-transform duration-200 hover:scale-105">
        <Phone className="w-4 h-4" /> Get Instant Quote
      </button>
      <button onClick={openBooking} data-testid="cta-book-btn"
        className={`px-7 py-4 rounded-full font-medium transition-all duration-200 hover:scale-105 ${dark ? "bg-white text-navy" : "bg-transparent text-navy border border-navy/25 hover:border-navy hover:bg-navy hover:text-white"}`}>
        Book Online
      </button>
    </div>
  );
};

export const CtaBand = () => {
  const { openProposal, openQuote } = useLeadModal();
  return (
    <section className="relative bg-navy text-white overflow-hidden grain" data-testid="cta-band">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-24 text-center relative z-10">
        <p className="text-xs uppercase tracking-[0.25em] text-leaf mb-5">Ready when you are</p>
        <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight leading-none mb-6">
          Ready to experience<br />the CJB difference?
        </h2>
        <p className="text-white/70 text-lg max-w-xl mx-auto mb-9">
          We'd love the opportunity to care for your home, workplace, or community space.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <button onClick={openQuote} data-testid="ctaband-quote-btn"
            className="group px-7 py-4 rounded-full bg-leaf text-white font-medium flex items-center justify-center gap-2 hover:scale-105 transition-transform">
            <Phone className="w-4 h-4" /> Get Instant Quote
          </button>
          <button onClick={openProposal} data-testid="ctaband-proposal-btn"
            className="px-7 py-4 rounded-full bg-white text-navy font-medium hover:scale-105 transition-transform">
            Request a Proposal
          </button>
        </div>
      </div>
    </section>
  );
};
